export default __webpack_public_path__ + "static/media/searchIcon.e0358c65.svg";